import axios from 'axios'
import qs from 'qs'
const service = axios.create({
  timeout: 10 * 1000,
  responseType: 'json',
  withCredentials: true,
  crossDomain: true,
  headers: {
    'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
  }
})

service.interceptors.request.use(
  config => {
    if(~config.url.indexOf('/usercollect/registV2/')) {
      config.headers = {
        'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
      }
      config.data = qs.stringify(config.data)
      config.withCredentials = false
    } else if (config.method === 'post' || config.method === 'POST') {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  () => {
    // console.error(error)
    Promise.reject()
  }
)

service.interceptors.response.use(
  response => {
    return response.data
  }
)

export default service
